import { user } from 'services/Utils';

const API_BASE_URL = process.env.REACT_APP_API_GIVEAWAYS_SERVER;

async function fetchAPI(path, options = {}) {
  let queryString = '';
  if (options.params) {
    const searchParams = new URLSearchParams(options.params);
    queryString = `?${searchParams.toString()}`;
    delete options.params;
  }

  const url = `${API_BASE_URL}${path}${queryString}`;

  const headers =
    options.body instanceof FormData
      ? options.headers
      : {
          'Content-Type': 'application/json',
          ...options.headers,
        };

  const response = await fetch(url, {
    ...options,
    headers,
  });

  if (response.status === 401) {
    localStorage.removeItem('auth');
    window.location.href = '/#/auth/signin';
  }

  if (response.status === 422) {
    return response.json();
  }

  if (!response.ok) {
    throw new Error(`API call failed: ${url}, status: ${response.status}`);
  }

  if (response.status === 204 || response.headers.get('Content-Length') === '0') {
    return null;
  }

  return response.json();
}

function userAuth() {
  return { Authorization: `Bearer ${user().token}` };
}

export const apiService = {
  /* General APIs */

  // auth
  async login(data) {
    return fetchAPI('/auth/login', {
      method: 'POST',
      body: JSON.stringify(data),
    });
  },
  async authTwoFA(data) {
    return fetchAPI('/auth/twofa', {
      method: 'POST',
      body: JSON.stringify(data),
      headers: userAuth(),
    });
  },
  /**/ async refreshToken(data) {
    return fetchAPI('/auth/refresh-token', {
      method: 'POST',
      body: JSON.stringify(data),
    });
  },
  async logout() {
    return fetchAPI('/auth/logout', { method: 'POST', headers: userAuth() });
  },
  // auth sessions
  async getMe() {
    return fetchAPI('/users/me', { method: 'GET', headers: userAuth() });
  },

  /* Admin APIs */

  // giveaways
  async getGiveaways(params) {
    return fetchAPI('/giveaways', {
      method: 'GET',
      params,
      headers: userAuth(),
    });
  },

  async getGiveaway(params) {
    return fetchAPI('/giveaways/' + params.id, {
      method: 'GET',
      params,
      headers: userAuth(),
    });
  },

  async getGiveawayWinners(params) {
    return fetchAPI(`/winners/${params.id}`, {
      method: 'GET',
      params,
      headers: userAuth(),
    });
  },

  async getGiveawayWinnersLogs(params) {
    return fetchAPI('/activity-logs', {
      method: 'GET',
      params,
      headers: userAuth(),
    });
  },

  async updateGiveawayWinner(data) {
    const {id, ...rest} = data;
    return fetchAPI(`/winners/${id}`, {
      method: 'PATCH',
      body: JSON.stringify(rest),
      headers: userAuth(),
    });
  },

  async deleteGiveawayWinner(params) {
    return fetchAPI(`/winners/${params.id}`, {
      method: 'DELETE',
      headers: userAuth()
    });
  },

  async revealGiveawayWinner(params) {
    return fetchAPI(`/winners/${params.id}/visible`, {
      method: 'PATCH',
      headers: userAuth()
    });
  },

  async generateWinner(params) {
    return fetchAPI(`/winners/generate/${params.giveawayId}`, {
      method: 'POST',
      params,
      headers: userAuth(),
    });
  },

  async generateWinners(data) {
    const {giveawayId, ...rest} = data;
    return fetchAPI(`/winners/generate/${giveawayId}/all`, {
      method: 'POST',
      body: JSON.stringify(rest),
      headers: userAuth(),
    });
  },

  async finishGiveaway(params) {
    return fetchAPI(`/giveaways/finish/${params.giveawayId}`, {
      method: 'POST',
      params,
      headers: userAuth(),
    });
  },

  async getGiveawaysEntriesCount(params) { return fetchAPI(`/giveaways/${params.id}/entries`, { method: 'GET', params, headers: userAuth()});},

  async getGiveawayDataFiles(params) {
    return fetchAPI('/giveaway-data-files', {
      method: 'GET',
      params,
      headers: userAuth(),
    });
  },

  async uploadGiveawayDataFile(params) {
    return fetchAPI(`/giveaway-data-files/${params.id}`, {
      method: 'POST',
      params,
      headers: userAuth(),
    });
  },

  async deleteGiveawayDataFile(params) {
    return fetchAPI(`/giveaway-data-files/${params.id}`, {
      method: 'DELETE',
      params,
      headers: userAuth(),
    });
  },
};


// userAuth()
